// Auto-generated resource for Auth — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const AuthKeys = {
  Login: {
    Title: 'Auth.Login.Title',
    WordmarkAria: 'Auth.Login.WordmarkAria',
    Heading: 'Auth.Login.Heading',
    Lede: 'Auth.Login.Lede',
    ReturnContext: 'Auth.Login.ReturnContext',
    GoogleLabel: 'Auth.Login.GoogleLabel',
    EmailLabel: 'Auth.Login.EmailLabel',
    EmailMeLinkAria: 'Auth.Login.EmailMeLinkAria',
    SendingLink: 'Auth.Login.SendingLink',
    EmailMeLink: 'Auth.Login.EmailMeLink',
    AltAction: 'Auth.Login.AltAction',
    CheckEmailHeading: 'Auth.Login.CheckEmailHeading',
    CheckEmailLede: 'Auth.Login.CheckEmailLede',
    LinkExpiresIn: 'Auth.Login.LinkExpiresIn',
    LinkExpired: 'Auth.Login.LinkExpired',
    OtpLabel: 'Auth.Login.OtpLabel',
    OtpInputAria: 'Auth.Login.OtpInputAria',
    Verify: 'Auth.Login.Verify',
    Verifying: 'Auth.Login.Verifying',
    ResendLinkAria: 'Auth.Login.ResendLinkAria',
    ResendIn: 'Auth.Login.ResendIn',
    ResendLink: 'Auth.Login.ResendLink',
    UseDifferentEmail: 'Auth.Login.UseDifferentEmail',
    SignedInHeading: 'Auth.Login.SignedInHeading',
    SignedInLede: 'Auth.Login.SignedInLede',
    OtpEnterCode: 'Auth.Login.OtpEnterCode',
    OtpExpired: 'Auth.Login.OtpExpired',
    OtpTooManyAttempts: 'Auth.Login.OtpTooManyAttempts',
    OtpInvalid: 'Auth.Login.OtpInvalid',
    OrSeparator: 'Auth.Login.OrSeparator',
    OAuthCancelled: 'Auth.Login.OAuthCancelled',
    OAuthFailed: 'Auth.Login.OAuthFailed',
  },
  Errors: {
    NotAuthenticated: 'Auth.Errors.NotAuthenticated',
  },
} as const;

export const AuthValues = {
  'default': {
    'Errors.NotAuthenticated': 'Sign in to do that.',
    'Login.AltAction': 'New or returning, it’s the same link — we’ll set up your account on the first click.',
    'Login.CheckEmailHeading': 'Check your email',
    'Login.CheckEmailLede': 'We sent a sign-in link to {Email}. Click it to finish signing in — this tab will continue automatically.',
    'Login.EmailLabel': 'Email',
    'Login.EmailMeLink': 'Email me a link',
    'Login.EmailMeLinkAria': 'Email me a link',
    'Login.GoogleLabel': 'Continue with Google',
    'Login.Heading': 'Let’s get you in',
    'Login.Lede': 'Pop in your email and we’ll send a link.',
    'Login.LinkExpired': 'Link expired — request a new one below',
    'Login.LinkExpiresIn': 'Link expires in {Time}',
    'Login.OAuthCancelled': 'Sign-in was cancelled — no harm done. Pick up wherever you like.',
    'Login.OAuthFailed': 'We couldn’t finish signing you in. Please try again.',
    'Login.OrSeparator': 'or',
    'Login.OtpEnterCode': 'Enter the 6-digit code from your email.',
    'Login.OtpExpired': 'That code has expired — request a new one below.',
    'Login.OtpInputAria': '6-digit sign-in code',
    'Login.OtpInvalid': 'That code isn’t right.',
    'Login.OtpLabel': 'Or enter the 6-digit code',
    'Login.OtpTooManyAttempts': 'Too many tries — request a new code.',
    'Login.ResendIn': 'Resend in {Seconds}s',
    'Login.ResendLink': 'Resend link',
    'Login.ResendLinkAria': 'Resend sign-in link',
    'Login.ReturnContext': 'Sign in to continue to {Label}.',
    'Login.SendingLink': 'Sending link…',
    'Login.SignedInHeading': 'Signed in',
    'Login.SignedInLede': 'Taking you in…',
    'Login.Title': 'Sign in · VoiceDojo',
    'Login.UseDifferentEmail': 'Use a different email',
    'Login.Verify': 'Verify',
    'Login.Verifying': 'Verifying…',
    'Login.WordmarkAria': 'VoiceDojo home',
  },
  'vi-VN': {
    'Errors.NotAuthenticated': 'Hãy đăng nhập để làm việc đó.',
    'Login.AltAction': 'Dù mới hay đã quen, vẫn là một liên kết duy nhất — chúng tôi sẽ tạo tài khoản cho bạn ngay lần nhấp đầu tiên.',
    'Login.CheckEmailHeading': 'Kiểm tra email của bạn',
    'Login.CheckEmailLede': 'Chúng tôi đã gửi liên kết đăng nhập tới {Email}. Hãy nhấp vào đó để hoàn tất đăng nhập — tab này sẽ tự động tiếp tục.',
    'Login.EmailLabel': 'Email',
    'Login.EmailMeLink': 'Gửi liên kết cho tôi',
    'Login.EmailMeLinkAria': 'Gửi liên kết cho tôi',
    'Login.GoogleLabel': 'Tiếp tục với Google',
    'Login.Heading': 'Mời bạn vào nhé',
    'Login.Lede': 'Nhập email của bạn và chúng tôi sẽ gửi một liên kết.',
    'Login.LinkExpired': 'Liên kết đã hết hạn — hãy yêu cầu liên kết mới bên dưới',
    'Login.LinkExpiresIn': 'Liên kết hết hạn sau {Time}',
    'Login.OAuthCancelled': 'Bạn đã huỷ đăng nhập — không sao cả. Bạn có thể thử lại bất cứ lúc nào.',
    'Login.OAuthFailed': 'Chúng tôi không hoàn tất được việc đăng nhập. Vui lòng thử lại.',
    'Login.OrSeparator': 'hoặc',
    'Login.OtpEnterCode': 'Nhập mã 6 chữ số từ email của bạn.',
    'Login.OtpExpired': 'Mã đó đã hết hạn — hãy yêu cầu mã mới bên dưới.',
    'Login.OtpInputAria': 'Mã đăng nhập 6 chữ số',
    'Login.OtpInvalid': 'Mã đó không đúng.',
    'Login.OtpLabel': 'Hoặc nhập mã 6 chữ số',
    'Login.OtpTooManyAttempts': 'Quá nhiều lần thử — hãy yêu cầu mã mới.',
    'Login.ResendIn': 'Gửi lại sau {Seconds} giây',
    'Login.ResendLink': 'Gửi lại liên kết',
    'Login.ResendLinkAria': 'Gửi lại liên kết đăng nhập',
    'Login.ReturnContext': 'Đăng nhập để tiếp tục đến {Label}.',
    'Login.SendingLink': 'Đang gửi liên kết…',
    'Login.SignedInHeading': 'Đã đăng nhập',
    'Login.SignedInLede': 'Đang đưa bạn vào…',
    'Login.Title': 'Đăng nhập · VoiceDojo',
    'Login.UseDifferentEmail': 'Dùng email khác',
    'Login.Verify': 'Xác minh',
    'Login.Verifying': 'Đang xác minh…',
    'Login.WordmarkAria': 'Trang chủ VoiceDojo',
  },
} as const;

